import { render, staticRenderFns } from "./BoCustomerEdit.vue?vue&type=template&id=e4cf4d54"
import script from "./BoCustomerEdit.vue?vue&type=script&lang=js"
export * from "./BoCustomerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports